/* eslint-disable */
import RestTypeEntity from "../Entity/RestType";
import RestTypeFactory from "../Factory/RestType";

let RestTypesRepository = Backbone.Collection.extend({
	model: RestTypeEntity
});

let repository = new RestTypesRepository();

repository.init = function (restTypes) {
	var restTypesModelsArray = [];

	_.each(restTypes, function (restTypeName, restTypeId) {
		var restTypesModel = new RestTypeFactory(restTypeName, restTypeId);
		restTypesModelsArray.push(restTypesModel);
	});
	this.set(restTypesModelsArray);
};

RestTypesRepository.repository = repository;

export default RestTypesRepository;